(() => {
  'use strict';
  if (customElements.get('mas-plant-promo')) return;
  customElements.define('mas-plant-promo', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      const cards = [...this.querySelectorAll('[data-mas-native-card]')];
      const search = this.querySelector('[data-promo-search]');
      const type = this.querySelector('[data-promo-type]');
      const stock = this.querySelector('[data-promo-stock]');
      const pagination = this.querySelector('[data-promo-pagination]');
      let page = 1;
      cards.forEach(card => { card.groups = (card.dataset.masGroups || '').split('|'); });
      [...type.options].forEach(option => { if (option.value && !cards.some(card => card.groups.includes(option.value))) option.remove(); });
      const update = () => {
        const query = search.value.trim().toLocaleLowerCase('en-AU');
        const matches = cards.filter(card => card.dataset.masName.toLocaleLowerCase('en-AU').includes(query) && (!type.value || card.groups.includes(type.value)) && (!stock.checked || card.dataset.masAvailable === 'true'));
        const pages = Math.max(1, Math.ceil(matches.length / 30));
        page = Math.min(page, pages);
        cards.forEach(card => { card.hidden = true; });
        matches.slice((page - 1) * 30, page * 30).forEach(card => { card.hidden = false; });
        this.querySelector('[data-promo-count]').textContent = matches.length + (matches.length === 1 ? ' eligible plant' : ' eligible plants');
        this.querySelector('[data-promo-empty]').hidden = matches.length > 0;
        this.querySelector('[data-promo-page]').textContent = 'Page ' + page + ' of ' + pages;
        this.querySelector('[data-promo-prev]').disabled = page === 1;
        this.querySelector('[data-promo-next]').disabled = page === pages;
        pagination.hidden = pages < 2;
      };
      const resetPage = () => { page = 1; update(); };
      search.addEventListener('input', resetPage, options);
      type.addEventListener('change', resetPage, options);
      stock.addEventListener('change', resetPage, options);
      this.querySelector('[data-promo-reset]').addEventListener('click', () => { search.value = ''; type.value = ''; stock.checked = false; resetPage(); }, options);
      ['prev', 'next'].forEach(direction => this.querySelector('[data-promo-' + direction + ']').addEventListener('click', () => {
        page += direction === 'next' ? 1 : -1;
        update();
        this.scrollIntoView({block: 'start', behavior: 'auto'});
      }, options));
      update();
    }
    disconnectedCallback() { if (this.abort) this.abort.abort(); this.abort = null; }
  });
})();
